<template>
    <div id='ClientRegisterPage' class="fit q-px-md">
        <q-card-section class="row client-title">
            <div class="col-9">
              <span class="text-h6 text-bold">{{ $gettext("CUSTOMER") }}:&nbsp;</span>
              <span class="text-h6 text-light">{{ name }}</span>
            </div>
        </q-card-section>
        <div class="row" :class="{'menu-grid': clientMeasuementHeightCss}" >
            <q-card class="col-sm-12 col-md-2 col-lg-2 q-ma-md q-py-sm menu-container" v-if="menus">
                <q-list class="buttons-list">
                    <q-item
                        v-for="item in menus"
                        :key="item"
                        clickable
                        v-ripple
                        :active="item.name === pageData.name"
                        @click="changeClientPageSelect(item)"
                        active-class="itemSelect"
                        class="item q-pa-md"
                        :data-testId="item.name"
                        :disabled="item.disabled"
                    >
                        <q-item-section avatar>
                            <q-icon
                                :color="item.name === pageData.name ? 'negative' : 'secondary'"
                                :name="item.icon"
                            />
                            </q-item-section>
                            <q-item-section class="ellipsis">
                                {{ $gettext(item.name) }}
                            </q-item-section>
                    </q-item>
                </q-list>
            </q-card>
            <q-card class="col-sm-12 col-md-9 col-lg-9 q-ma-md form-component-container" v-if="pageData.name">
                <div class="title-card-client">
                    <span class="text-h6">{{ $gettext(pageData.title) }}</span>
                </div>
                <component
                ref="dynamicForm"
                :id="pageData.id"
                :is="pageData.component"
                :name="pageData.name"
                :params="pageData.params"
                :forms="pageData.forms"
                :datatable="pageData.datatable"
                :parent="pageData.parent"
                :nmInterface="pageData.interface"
                :interface="pageData.interface"
                :controllerSearch="true"
                :client="clientForm"
                :addressPersonBillingState="clientCharger"
                :collectionPoints="collectionPoints"
                :contracts="contracts"
                @removeContract= "removeContract"
                @action-button="actionButton"
                @show-message="showMessage"
                @addCollectionPoint="addCollectionPoint"
                @conclude="conclude"
                @save-charge="saveCharge"
                class="client-container generator-client"
                clean-layout
                />
            </q-card>
        </div>
    </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { repository, messageBox } from 'jtech'
import { JtCrud } from 'jtech-webcomps'
import { registerMenu } from './clientRegister.config'
import ClientForm from './client-model/client.form'
import ClientChargeForm from './client-model/client-charge.form'
import ContractObj from '../contract/contract-model/contract.object'
import ClientObj from './client-model/client.object'
import contractRepository from '../contract/ContractRepository'
import ServiceTypeContants from '../contract/ServiceTypeContants'

const { CrudLayout } = JtCrud

@Component({
  name: 'ClientRegisterPage',
  components: {
    CrudLayout
  },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class ClientRegisterPage extends Vue {
  pageData = {};
  clientMeasuementHeightCss = false;
  nextButton = 'btConfirmar';
  previousButton = 'btExecutar'
  clientForm = new ClientForm()
  clientCharger = new ClientChargeForm()
  collectionPoints = []
  clientObj = new ClientObj()
  contractObj = new ContractObj()
  contracts = []

  TONNE = 20090001;
  KILOGRAM = 20090002;
  UNITY = 20090007;

  backToSearch (resContractAndClient) {
    this.$router.push({
      name: 'clientPage',
      params: {
        id: resContractAndClient.data.contract.client,
        name: resContractAndClient.data.client.name,
        reload: true,
        link: 'clientPage'
      },
      force: true,
      reload: true
    })
  }

  get menus () {
    return registerMenu
  }

  beforeMount () {
    this.changeClientPageSelect(this.menus[0])
  }

  async changeClientPageSelect (item) {
    if (item.disabled) {
      return
    }
    const pageData = {}
    pageData.crud = item.crud
    if (!pageData.crud) {
      const forms = await repository.resolve(item.interface, this.params)
      pageData.forms = forms
    }
    pageData.component = item.component
    pageData.name = item.name
    pageData.id = item.name
    pageData.interface = item.interface
    pageData.params = {
      name: item.name,
      client: this.id
    }
    pageData.datatable = null
    pageData.title = item.title
    this.pageData = pageData
    if (item.name == 'MEASUREMENTS') {
      pageData.id = this.id
      this.clientMeasuementHeightCss = true
    } else {
      this.clientMeasuementHeightCss = false
    }
  }

  async actionButton (button, params, page) {
    await repository.resolveLogic(button.action, params)
    switch (button.name) {
      case this.nextButton:
        await repository.resolveLogic(button.action, params)
        this.next()
        break
      case this.previousButton:
        this.previous()
        break
    }
  }

  async saveCharge (event) {
    this.clientCharger = event
  }

  generateClientContacts (clientForm) {
    const contacts = []
    if (clientForm.personPhone) {
      contacts.push(clientForm.personPhone)
    }
    if (clientForm.personAlternativePhone) {
      contacts.push(clientForm.personAlternativePhone)
    }
    return contacts
  }

  formToClient (clientForm) {
    const clientRequest = {
      typeAccount: clientForm.clientDescription === ServiceTypeContants.PUBLIC_CLIENT_CODE ? 'Public' : 'Private',
      stateRegistration: clientForm.stateRegistration,
      registryDate: new Date(),
      name: clientForm.personName,
      municipalRegistration: clientForm.municipalRegistration,
      marketClient: 'Commercial',
      mainContact: {
        phones: this.generateClientContacts(clientForm),
        name: clientForm.personName,
        id: null,
        emails: clientForm.personEmail ? [clientForm.personEmail] : [],
        description: ''
      },
      fantasyName: clientForm.fantasyName,
      document: clientForm.personDocument,
      billingContact: {
        phones: this.generateClientContacts(clientForm),
        name: clientForm.personName,
        id: null,
        emails: clientForm.personEmail ? [clientForm.personEmail] : [],
        description: ''
      },
      address: {
        zip: clientForm.zipCode,
        street: clientForm.addressName,
        state: clientForm.stateText,
        number: clientForm.number,
        neighborhood: clientForm.neighborhood,
        complement: clientForm.detail,
        city: clientForm.cityText
      },
      activityArea: clientForm.activityAreaText,
      comingFromWasteInterface: true
    }
    return clientRequest
  }

  getUnitMeasureType (contractItem) {
    if (contractItem && contractItem.unitMeasureType) {
      switch (contractItem.unitMeasureType) {
        case ServiceTypeContants.TONNE:
          return this.$gettext('TONNE_LABEL')
        case ServiceTypeContants.KILOGRAM:
          return this.$gettext('KILOGRAM_LABEL')
        case ServiceTypeContants.UNITY:
          return this.$gettext('UNITY_LABEL')
        case ServiceTypeContants.TRIP:
          return this.$gettext('TRIP_LABEL')
        case ServiceTypeContants.BUCKET:
          return this.$gettext('BUCKET_LABEL')
        default:
          return contractItem.unitMeasureTypeText
      }
    }

    return null
  }

  getServiceType (service) {
    if (service && service.serviceType) {
      switch (service.serviceType) {
        case ServiceTypeContants.WASTE_COLLECTION:
          return 'coleta'
        case ServiceTypeContants.FINAL_DESTINATION:
          return 'destinacao'
        case ServiceTypeContants.RCC:
          return 'rcc'
        case ServiceTypeContants.SHIPPING:
          return 'frete'
        case ServiceTypeContants.VALORIZATION:
          return 'venda valorizacao'
        case ServiceTypeContants.ETE:
          return 'ete'
        case ServiceTypeContants.AUTOCLAVE:
          return 'autoclave'
        case ServiceTypeContants.CONTRACT_MAINTENANCE:
          return 'taxa_manutencao_contrato'
        case ServiceTypeContants.RECEIPT_VALORIZATION:
          return 'recebimento valorizacao'
        default:
          return service.serviceTypeText
      }
    }

    return null
  }

  generateContractItems (contract) {
    const contractItemsRequest = []
    contract.services.forEach(service => {
      service.contractItems.forEach(contractItem => {
        contractItemsRequest.push({
          unitPrice: contractItem.unitPrice?.toString().replaceAll('.', '').replace(',', '.'),
          unitMeasureType: this.getUnitMeasureType(contractItem),
          treatmentType: null,
          totalValueItem: null,
          serviceType: this.getServiceType(service),
          reajustmentIndex: contractItem.readjustmentIndexText,
          productId: contractItem.product,
          productGroupDescription: '',
          productDescription: contractItem.productText,
          mtr: false,
          minimumBilling: contractItem.minimalBilling?.toString().replaceAll('.', '').replace(',', '.'),
          measurementStart: service.measurementStart?.toString().replaceAll('.', '').replace(',', '.'),
          landfillTax: 0.0,
          landfill: contractItem.landfill,
          globalDescription: null,
          globalCode: null,
          contractBidQuantity: contractItem.contractBidQuantity?.toString().replaceAll('.', '').replace(',', '.'),
          classType: contractItem.residueTypeText,
          billingMeasurementType: service.billingMeasurementTypeText,
          billForType: true,
          invertedWeighing: contractItem.invertedWeighing,
          useEnvironmentalWeightForBilling: contractItem.useEnvironmentalWeightForBilling,
          excessValue: contractItem.excessValue?.toString().replaceAll('.', '').replace(',', '.'),
          quantityUpTo: contractItem.quantityUpTo?.toString().replaceAll('.', '').replace(',', '.'),
          carrier: contractItem?.carrier,
          destination: contractItem?.destination,
          billingType: contractItem.contractBillingType?.toString(),
          contractItemBilling: (contractItem.contractItemBilling || []).map(billing => ({
            quantity: billing.quantity,
            value: billing.value.toString().replace(',', '.')
          }))
        })
      })
    })

    return contractItemsRequest
  }

  generateCollectionPoints (contract, collectionPoints, client) {
    const collectionPointsRequest = []
    collectionPoints.forEach(collectionPoint => {
      collectionPointsRequest.push({
        name: collectionPoint.name,
        detail: collectionPoint.detail ? collectionPoint.detail : 'NA',
        latitude: collectionPoint.latitude,
        longitude: collectionPoint.longitude,
        areaCode: collectionPoint.areaCode,
        description: collectionPoint.description,
        address: {
          zip: collectionPoint.addressZipCode,
          street: collectionPoint.addressName,
          state: collectionPoint.stateRegistration,
          number: collectionPoint.addressNumber,
          neighborhood: collectionPoint.addressNeighborhood,
          complement: collectionPoint.addressDetail,
          city: collectionPoint.cityRegistration
        }
      })
    })
    return collectionPointsRequest
  }

  formatDateString (date) {
    const arrDate = date.split('/')
    return arrDate[2] + '-' + arrDate[1] + '-' + arrDate[0]
  }

  getContractBirth (date) {
    const arrDate = date.split('/')
    const year = Number(arrDate[2]) + 1
    return year + '-' + arrDate[1] + '-' + arrDate[0]
  }

  formToContract (client, contract) {
    const contractRequest = {
      totalValue: null,
      startOperation: new Date(),
      readjustmentDate: this.formatDateString(contract.readjustmentDate),
      paymentInstrument: contract.paymentInstrumentText,
      paymentConditionCode: contract.paymentCondition,
      minimumBilling: contract.minimalBilling.toString().replaceAll('.', '').replace(',', '.'),
      justification: '',
      contractStart: this.formatDateString(contract.contractStart),
      contractRootNumber: null,
      contractNumber: contract.contractNumberCrm,
      contractItem: this.generateContractItems(contract),
      contractId: null,
      contractEnd: this.formatDateString(contract.contractEnd),
      contractBirth: this.getContractBirth(contract.contractStart),
      companyId: client.company,
      collectionPoint: this.generateCollectionPoints(contract, this.collectionPoints, client),
      clientDocument: client.personDocument,
      blockIfOverdue: contract.blockIfOverdue,
      alterationDate: new Date(),
      additiveNumber: 0.0,
      originOfIntegration: '20440001'
    }
    return contractRequest
  }

  conclude (contracts) {
    const clientRequest = this.formToClient(this.clientForm)
    const contractRequest = this.formToContract(this.clientForm, this.contracts[0])
    this.callEndpointSave(clientRequest, contractRequest)
  }

  callEndpointSave (clientRequest, contractRequest) {
    const contractAndClientRequest = {
      clientRequest: clientRequest,
      contractRequest: contractRequest
    }
    contractRepository.saveContractAndClient(contractAndClientRequest).then(resContractAndClient => {
      messageBox.success(this.$gettext('CONTRACT_AND_CLIENT_SAVED'))
      this.backToSearch(resContractAndClient)
    }).catch(err => {
      messageBox.error(this.$gettext('CONTRACT_AND_CLIENT_NOT_SAVED'))
      console.error(err)
    })
  }

  previous () {
    let nextItemIndex = this.menus.findIndex(item => item.name === this.pageData.id)
    nextItemIndex = nextItemIndex > 0 ? nextItemIndex - 1 : nextItemIndex
    this.pageData = this.changeClientPageSelect(this.menus[nextItemIndex])
  }

  next () {
    let nextItemIndex = this.menus.findIndex(item => item.name === this.pageData.id)
    nextItemIndex = nextItemIndex === this.menus.length - 1 ? nextItemIndex : nextItemIndex + 1
    this.menus[nextItemIndex].disabled = false
    this.pageData = this.changeClientPageSelect(this.menus[nextItemIndex])
  }

  showMessage (type, message, page) {
    messageBox.warn(this.$gettext(message))
  }

  addCollectionPoint (newCollectionPoints) {
  }

  removeContract (event) {
    this.contracts = event
  }
}
export default ClientRegisterPage
</script>
<style lang="stylus" scoped>
.client-title {
    padding: 20px 20px 0px;
}
.text-light {
    font-weight: 400;
}
.title-card-client {
    padding: 10px 0px 0px;
    margin: 0px 15px;
    border-bottom: 0.3px solid $faded !important;
}
.menu-container {
  height: 500px;
}
.form-component-container {
  padding: 20px;
}
</style>
